export default "__VITE_ASSET__BNZj9hQo__"